module.exports = __webpack_public_path__ + "static/unique-online-store-b793b12a6c4cb4bc83df7511b63e91ad.png";